module.exports = __webpack_public_path__ + "img/logo-vrjmof2024.22b74ae0.svg";